import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './app/ProtectedRoute';
import PasswordChangeSuccess from 'app/employee_session/PasswordChangeSuccess';
import UnifiedLogin from './app/session/login';
import { NotificationProvider } from 'app/contexts/NotificationContext';
import EmployeePasswordReset from 'app/employee_session/PasswordChangeForm';
import Layout from 'app/main_components/Layout';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Redirect root path to employee login */}
      <Route path="/" element={<Navigate to="/employee-login" replace />} />

      {/* Public Routes */}
      <Route path="/employee-login" element={<UnifiedLogin />} />
      <Route path="/reset-password" element={<UnifiedLogin isEmployeeLogin={false} isResetPassword={true} />} />
      <Route path="/employee-password-change" element={<EmployeePasswordReset />} />
      <Route path="/password-change-success" element={<PasswordChangeSuccess />} />

      {/* Protected Routes */}
      <Route
        path="/main"
        element={
          <ProtectedRoute>
            <NotificationProvider>
              <Layout />
            </NotificationProvider>
          </ProtectedRoute>
        }
      />

      {/* Redirect all unknown paths to employee login */}
      <Route path="*" element={<Navigate to="/employee-login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
